import { Link } from "react-router-dom"






export default function ListItems({symbol,setOpen}){

    return(
        <>


        {symbol && symbol.map((sym) => (

            <Link className="itemrowdiv"
            to={`/${sym['symbol'].split('-')[0]}`} onClick={()=>setOpen(false)}>
            
            
                        <Link className="col-4 pointer linkStyle"
                       to={`/${sym['symbol'].split('-')[0]}`} onClick={()=>setOpen(false)}>
                        <div className="text-black">
                            <img className="imgcoin2002 "
                                 src={`https://static.sinatether.com/CoinsImg/${sym['symbol'].split('-')[0]}.png`} alt={""}/>
                            <span
                                className="spanHeaderAcc">  <span
                                className="ft-external-link text-large text-normal dis-grid text-dark">{sym['persionName'].length >=12 ? `${sym['persionName'].slice(0,9)}..`: sym['persionName']}
                                <span
                                className="text-medium text-muted">{sym['symbol'].split('-')[0]}</span>
                                </span>
                                
                                </span>
            
                        </div>
                    </Link>
            
            
            
            
                    <div
                        className="col-4 pointer text-right text-blue-primery text-large text-dark line-height-48"
                    >{new Intl.NumberFormat("fa",{maximumFractionDigits:sym['sell']>1 ? 3 : 13 }).format(sym['sell'])}
                     
                        </div>
                            <div
                            className="col-4 pointer text-right text-blue-primery text-large priceTt pt-13"
                        >
            
                        <span
                            className={'text-normal priceTt '}>
                            {sym['changeRate']>=0 ?
                                <>
            
            
                                      <svg id="up.0f59dd92" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                                      <path id="Path_1" data-name="Path 1" d="M16,0H0V16H16Z" fill="rgba(255,255,255,0.01)"/>
                                      <path id="Path_2" data-name="Path 2" d="M13.668,9V5h-4" fill="none" stroke="#29cd97" strokeWidth="1.333"/>
                                      <path id="Path_3" data-name="Path 3" d="M2,12.333,5.446,8.167l3.282,2L13.667,5" fill="none" stroke="#06a969" strokeWidth="1.333"/>
                                    </svg>
            
            
                            <span className={'text-success pl-1'}>
                                {sym['changeRate']}%
            
                            </span>
                                      </>
            
                                :
            
                                <>
            
            
            
            
            
            
                        <svg id="down.75125799" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                          <path id="Path_4" data-name="Path 4" d="M16,16H0V0H16Z" fill="rgba(255,255,255,0.01)"/>
                          <path id="Path_5" data-name="Path 5" d="M13.668,7v4h-4" fill="none" stroke="#f5455b" strokeWidth="1.333"/>
                          <path id="Path_6" data-name="Path 6" d="M2,3.667,5.446,7.833l3.282-2L13.667,11" fill="none" stroke="#f5455b" strokeWidth="1.333"/>
                        </svg>
            
            
            
                            <span className={'text-danger pl-1'}>
                                {-1 * Number(sym['changeRate'])}%
            
                            </span>
            
            
                                </>
                            }
                        </span>
            
            
                        </div>
                        </Link>
            
            
            
            
                        ))}

        
        </>
    )
}